import { Box } from '@mui/material';
import type { CSSProperties } from 'react';
import { TermChip, Typography } from '../../atoms';
import type { TermChipVariant } from '../../atoms/TermChip/TermChip';

// Read-only cell: label on one line with the term chip on the next line.
export const TermTypeCell = ({
    label,
    term,
    variant = 'default',
    labelSx
}: {
    label: string;
    term?: string;
    variant?: TermChipVariant;
    labelSx?: CSSProperties;
}) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }}>
        <Typography label={label} variant="body.large" sx={labelSx} />
        <TermChip term={term} variant={variant} />
    </Box>
);
